import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { translation } from "./Translation";
import { createSearchEnterHandler } from "./searchInputHelpers";
import { useVisitorLanguage } from "./useVisitorLanguage";

const DefaultSearchBar = () => {
  const navigate = useNavigate();
  const lang = useVisitorLanguage();
  const [searchText, setSearchText] = useState("");

  const runSearch = () => {
    const query = searchText.trim();
    if (query) {
      sessionStorage.setItem("shopSearchQuery", query);
    } else {
      sessionStorage.removeItem("shopSearchQuery");
    }
    navigate("/");
  };

  return (
    <>
      <div className="pos-rel-search">
        <input
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          onKeyDown={createSearchEnterHandler(runSearch)}
          type="text"
          placeholder={
            translation.toast_error003[lang]
              ? translation.toast_error003[lang]
              : "جستجو کنید"
          }
        />
        <svg
          onClick={runSearch}
          className="search-svg c-p"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
            stroke="#A2A2A2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.5 16.958L21.5 21.958"
            stroke="#A2A2A2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </>
  );
};

export default DefaultSearchBar;
